import { styled } from '@mui/system';
import { Button, Tab, Paper } from '@mui/material';

export const DashBoardButton = styled(Button)({
	fontFamily: 'Gilroy-Medium',
	fontSize: '16px',
	fontStyle: 'normal',
	fontWeight: 400,
	lineHeight: 'normal',
	color: 'black',
	backgroundColor: '#B7D423'
});

export const MainTab = styled(Tab)({
	iconPosition: 'start',
	fontFamily: 'Gilroy-Medium',
	fontSize: '16px',
	fontStyle: 'normal',
	fontWeight: 400,
	lineHeight: 'normal'
});

export const DropzoneContainer = styled(Paper)(({ theme }) => ({
	padding: theme.spacing(2),
	textAlign: 'center',
	cursor: 'pointer',
	border: '2px dashed #B7D423', // Border color
	backgroundColor: '#fafafa',
	// Height: dropzoneHeight,
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	borderRadius: '15px',
	transition: 'height 0.5s ease'
}));

export const UAMButton = styled(Button)({
	flex: 1,
	maxWidth: '15%',
	variant: 'contained',
	background: '#B7D423',
	color: 'black',
	fontFamily: 'Gilroy-SemiBold',
	fontSize: '14px',
	fontStyle: 'normal',
	fontWeight: 400,
	lineHeight: 'normal',
	bordeRadius: '8px',
	height: '40px',
	padding: ' 10px 16px',

	'&:hover': {
		boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.4)', // Shadow on hover
		backgroundColor: '#B7D423'
	}
});
export const scrollstyleCss = {
	'&::-webkit-scrollbar': {
		width: '8px'
	},
	'&::-webkit-scrollbar-thumb': {
		backgroundColor: '#d9d9d9',
		borderRadius: '3px'
	},
	'&::-webkit-scrollbar-thumb:hover': {
		backgroundColor: 'rgb(68, 68, 68)' // Hover background color
	},
	'&::-webkit-scrollbar-track': {
		backgroundColor: '#f1f1f1' // Track background color
	}
};
